import styled from 'styled-components/macro';

export const Container = styled.div`
  position: absolute;
  right: 0;
  top: 80%;
  z-index: 999;
  padding: 15px;
  pointer-events: ${({ showBox }) => (showBox ? 'auto' : 'none')};

  @media screen and (max-width: 319px) {
    right: -1.5%;
  }
  @media screen and (max-width: 312px) {
    right: -2%;
  }
  @media screen and (max-width: 306px) {
    right: -2.8%;
  }
  @media screen and (max-width: 303px) {
    right: -3.6%;
  }
  @media screen and (max-width: 300px) {
    right: -4%;
  }
  @media screen and (max-width: 296px) {
    right: -4.5%;
  }
  @media screen and (max-width: 295px) {
    right: -4.8%;
  }
  @media screen and (max-width: 293px) {
    right: -5.3%;
  }
  @media screen and (max-width: 290px) {
    right: -5.7%;
  }
  @media screen and (max-width: 288px) {
    right: -6%;
  }
  @media screen and (max-width: 286px) {
    right: -6.3%;
  }
  @media screen and (max-width: 283px) {
    right: -7.4%;
  }
`;

export const Profile = styled.img`
  transition: 0.25s all ease-in-out;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 4px solid white;
  box-sizing: border-box;
  cursor: pointer;
  box-shadow: 0 0 10px 3px rgb(0 0 0 / 25%);

  &:hover {
    opacity: 0.9;
  }
  &:active {
    transform: scale(0.95);
  }
`;

export const ConfirmButtons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 5px;

  & .button {
    transition: all 0.25s ease-in-out;
    cursor: pointer;
    padding: 7px 12px;
    font-weight: bold;
    border-radius: 8px;

    &:active {
      transform: scale(0.98);
    }
  }
  & .button-confirm {
    margin-right: 5px;
    color: white;
    background: ${({ color }) => color};
    &:hover {
      opacity: 0.85;
    }
  }

  & .button-cancel {
    color: rgba(0, 0, 0, 0.6);

    background: rgba(0, 0, 0, 0.15);
    &:hover {
      opacity: 0.8;
    }
  }
`;

export const OverlayButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s ease-in-out;
box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  cursor: pointer;
  font-weight: bold;

  padding: 13px;

  ${({ disabled }) =>
    disabled &&
    `
          opacity: 0.5;
          pointer-events: none;

        `}

  &:hover {
    opacity: 0.8;
  }

  &:active {
    transform: scale(0.98);
  }

  background: ${({ background }) => background};
  color: ${({ color }) => color};

  & > span {
    margin-left: 8px;
  }

  ${({ display }) =>
    display == 'bottom'
      ? `border-bottom-left-radius: 15px;border-bottom-right-radius: 15px;`
      : display == 'top'
      ? `border-top-left-radius: 15px;border-top-right-radius: 15px;`
      : `border-radius: 15px;`}

  ${({ corner }) => corner && `border-radius: 12px; `}
`;
